// extracted by mini-css-extract-plugin
module.exports = {"saturday":"saturday__l3Cls","sunday":"sunday__29Huz"};